import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SatisfyWithSkinCondition = lazyWithPreload(
  () => import('./SatisfyWithSkinCondition'),
)
export const LikeChatSkinQuality = lazyWithPreload(
  () => import('./LikeChatSkinQuality'),
)
